
import React from 'react'
import Box from './Box'

/**
 * Spinner component.
 */

export default function Spinner({ size = 4, thickness = 1, color = '', ...props }) {
  const style = {
    '--size': `${size * 0.25}rem`,
    '--thickness': `${thickness}px`,
    '--color': color
  }

  return <Box
    is="span"
    className="Spinner"
    style={style}
    {...props} />
}